var map = {
	"./Disabled.svg": 2829,
	"./HasWarnings.svg": 2830,
	"./Healthy.svg": 2831,
	"./Unavailable.svg": 2832,
	"./Unhealthy.svg": 2833,
	"./Unknown.svg": 2834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1356;